import React from 'react'
import { Link } from 'react-router-dom'

import Links from '../../constants'
import {
  Logo,
  FAppStoreIcon,
  FGooglePlayIcon,
  FPhoneIcon,
  FEmailIcon,
  FGPayIcon,
  FAPayIcon,
} from '../../../../assets/svgs/landingV2/guest'

import './styles.scss'
import './responsiveStyles.scss'
import { Mastercard, Visa } from '../../../../assets/svgs/landing'

function Footer() {
  return (
    <div className='bl_footer'>
      <div className='bl_footer__info'>
        <div className='bl_footer__info_logo'>
          <img src={Logo} alt='Pinka logo' />
        </div>

        <div className='bl_footer__info_links'>
          <h6>Завантажити</h6>
          <div className='bl_footer__info_links_buttons'>
            <div>
              <img src={FGooglePlayIcon} alt='Google play' />
              <a href={Links.linkToBaristaGooglePlay}>Google Play</a>
            </div>
            <div>
              <img src={FAppStoreIcon} alt='App store' />
              <a href={Links.linkToBaristaAppStore}>App Store</a>
            </div>
          </div>
        </div>

        <div className='bl_footer__info_contacts'>
          <h6>Контакти</h6>
          <div className='bl_footer__info_contacts_item'>
            <img src={FPhoneIcon} alt='Phone icon' />
            <a href='tel:+38 (063) 31 25 695'>+38 (063) 31 25 695</a>
          </div>
          <div className='bl_footer__info_contacts_item'>
            <img src={FEmailIcon} alt='Email icon' />
            <a href='mailto: contact@pinka.com '>contact@pinka.com</a>
          </div>
        </div>

        <div className='bl_footer__info_payments'>
          <h6>Способи оплати</h6>
          <div className='bl_footer__info_payments_logos'>
            <img src={FGPayIcon} alt='Google Pay' />
            <img src={FAPayIcon} alt='Apple Pay' />
          </div>
          <div className='bl_footer__info_payments_logos'>
            <img src={Mastercard} alt='Mastercard' />
            <img src={Visa} alt='Visa' />
          </div>
        </div>
      </div>

      <div className='bl_footer__terms'>
        <Link to='/terms_and_conditions'>
          Правила і умови
        </Link>
        <Link to='/privacy_policy'>
          Умови конфіденційності
        </Link>
      </div>
    </div>
  )
}

export default Footer
